import React from "react";
import PolicyLayout from "../PolicyLayout";

const InterestRatePolicy: React.FC = () => {
  const policySections = [
    {
      title: `1. ${import.meta.env.VITE_COMPANY_NBFC} (Brand Name: ${import.meta.env.VITE_COMPANY_NAME})`,
      content: `The Reserve Bank of India (RBI) through its notification DNBS.204/CGM (ASR)-2009 dated January 2, 2009, and the Master Direction DNBR. PD. 007/03.10.119/2016-17 dated September 1, 2016, directs NBFCs and their Boards to review and implement internal interest rate models that factor in the cost of funds, margin, and risk premium. ${import.meta.env.VITE_COMPANY_NBFC} ("Company"), operating under the brand "${import.meta.env.VITE_COMPANY_NAME}," complies with these guidelines and has formulated this Interest Rate Policy in line with the Fair Practices Code.`,
    },
    {
      title: "2. Disclosure",
      content: `The Company's interest rate determination process—including applicable rates and charges—is transparently disclosed on its official website and shared with customers during the loan process.`,
    },
    {
      title: "3. Interest Rate",
      list: [
        "This policy is approved by the Board of Directors and incorporates key factors: cost of funds, margin, and risk premium.",
        "Rates vary by borrower based on risk profile, credit score, and operational costs.",
        "Loan amounts range from ₹5,000 to ₹1,00,000 with tenures between 7 days and 3 months.",
        "Maximum annual rates for Q4 FY2025: 108% (Personal loans), 510.25% (Salary Advance loans).",
        "Target maximum rates for Q4 FY2026: 72% (Personal loans), 382.5% (Salary Advance loans).",
        "All loans are Fixed Rate and repaid through EMIs or Bullet repayment. Interest is payable on due date; penal interest applies for delays.",
      ],
    },
    {
      title: "4. Fees & Charges",
      list: [
        "Borrowers pay fees such as processing, credit assessment, or origination (10–15% of loan amount).",
        "Additional charges apply for EMI returns, rescheduling, or special services.",
        "Applicable taxes and cesses are levied as per law, and all revisions are prospective.",
        "Refunds or waivers may be granted solely at the Company's discretion.",
      ],
    },
    {
      title: "5. Customer Communication",
      content:
        "The final interest rate, applicable fees, and charges are clearly communicated to the borrower at loan sanction through a Sanction Letter and loan documentation. Borrowers receive a copy of the signed loan agreement after disbursal.",
    },
    {
      title: "6. Amendment",
      content:
        "This policy may be revised or updated at any time with the approval of the Board of Directors. All changes, once approved, take immediate effect.",
    },
  ];

  return (
    <PolicyLayout 
      title="Interest Rate Policy" 
      subtitle={`At ${import.meta.env.VITE_COMPANY_NAME}, we follow transparent and responsible lending practices in line with the Reserve Bank of India’s guidelines for NBFCs.`}
      badge="Lending Standards 📈"
    >
      {policySections.map((section, idx) => (
        <div key={idx} className="space-y-6">
          <h2 className="text-3xl font-black text-[#0F172A] tracking-tight">
            {section.title}
          </h2>

          {section.content && (
            <p className="text-[var(--text-secondary)] text-lg leading-relaxed font-medium whitespace-pre-line">
              {section.content}
            </p>
          )}
          
          {section.list && (
            <ul className="space-y-4">
              {section.list.map((li, i) => (
                <li key={i} className="flex items-start gap-3 text-[var(--text-secondary)] text-lg font-medium">
                  <span className="w-1.5 h-1.5 rounded-full bg-[var(--primary)] mt-2.5 flex-shrink-0" />
                  {li}
                </li>
              ))}
            </ul>
          )}
        </div>
      ))}
    </PolicyLayout>
  );
};

export default InterestRatePolicy;
